module.exports = __webpack_public_path__ + "static/media/Granbull_gaussian2.021a55be.png";